exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Wrapper___15kcB {\n  height: 100%;\n}", ""]);

// exports
exports.locals = {
	"Wrapper": "Wrapper___15kcB"
};